import API from './base';
import { getToken } from '../helpers';

export default class InquiriesApi extends API {
  getInquiryById({ id }) {
    return this.get(`api/scoring/v2/service/score/${id}`, getToken(), false);
  }
}
